const BranchLocatorIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1518_132472)">
        <path
          d="M1.09041 9.45598H2.18131V16.7287H4.36312V9.45598H7.99946V16.7287H10.1813V9.45598H13.8176V16.7287H15.9994V9.45598H19.6358V16.7287H21.8176V9.45598H22.9085C23.3891 9.45598 23.8133 9.14129 23.9525 8.68122C24.0918 8.22115 23.9135 7.72406 23.5135 7.45737L12.6045 0.184688C12.2381 -0.0595283 11.7607 -0.0595283 11.3943 0.184688L0.485248 7.45737C0.0852504 7.72406 -0.093003 8.22115 0.0462689 8.68122C0.185613 9.14129 0.609756 9.45598 1.09041 9.45598Z"
          fill="#606062"
        />
        <path
          d="M22.9099 18.9103H21.819H19.6372H16.0009H13.8191H10.1827H8.00093H4.36459H2.18278H1.09188C0.48941 18.9103 0.000976562 19.3987 0.000976562 20.0012V22.9103C0.000976562 23.5127 0.48941 24.0012 1.09188 24.0012H22.9099C23.5124 24.0012 24.0008 23.5127 24.0008 22.9103V20.0012C24.0008 19.3987 23.5124 18.9103 22.9099 18.9103Z"
          fill="#606062"
        />
      </g>
      <defs>
        <clipPath id="clip0_1518_132472">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BranchLocatorIcon;
